module.exports = __webpack_public_path__ + "img/nav-signout.bea92597.svg";